@if (loaderService.isLoading()) {
<app-loader></app-loader>
}

<app-header></app-header>
@if (authSrv.isLoggedIn()() && (currentBreakpoint$ | async) !== 'xs') {
<app-side-menu></app-side-menu>
}

<div class="tas-page" [class.tas-page-padding]="authSrv.isLoggedIn()()">
    <router-outlet></router-outlet>
</div>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>